import qs from 'qs';
import {
  getCooikeShareFacebook,
  getCooikeShareKakaotalk,
  setCookieShareFacebook,
  setCookieShareKakaotalk,
} from './cookie';

const appScheme = 'wconceptkr';
const appActionOpenBrowser = 'openBrowser';

/**
 * App 에 정의되어 있는 action 호출
 */
const actionApp = (action: string, param: { [key: string]: string }) => {
  const url = `${appScheme}://${action}?${qs.stringify(param)}`;
  window.location.href = url;
};

const openBrowser = (url: string) => {
  actionApp(appActionOpenBrowser, { url });
};

const formatUrl = (url: string) => {
  if (
    !url.toLowerCase().startsWith('http://') &&
    !url.toLowerCase().startsWith('https://')
  ) {
    return `https://${url}`;
  }
  return url;
};

export const onFacebook = async (
  curUrl: string,
  isApp: boolean,
  isDesktop: boolean
) => {
  const url = formatUrl(curUrl);
  const href = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
    url
  )}`;
  const shareFacebookCookie = await getCooikeShareFacebook();
  const confirmMessage = '“W컨셉”에서 “페이스북”을(를) 열려고 합니다.';

  // 사용자 확인 받기
  if (isApp && shareFacebookCookie !== 'Y' && !window.confirm(confirmMessage)) {
    return;
  }

  // 앱에서 페이스북 공유
  if (isApp) {
    if (shareFacebookCookie !== 'Y') {
      await setCookieShareFacebook('Y');
    }
    openBrowser(href);
  } else {
    // 데스크탑 또는 모바일 웹에서 팝업 창으로 페이스북 공유
    window.open(href, 'popSnsShare', 'width=600,height=300');
  }
};

export const onKakao = async (
  description: string,
  curUrl: string,
  isNativeAppBoth: boolean,
  isDesktop: boolean
) => {
  const url = formatUrl(curUrl);
  const shareKakaotalk = await getCooikeShareKakaotalk();
  const confirmMessage = '“W컨셉”에서 “카카오톡”을(를) 열려고 합니다.';

  // 사용자에게 확인 받음
  if (
    isNativeAppBoth &&
    shareKakaotalk !== 'Y' &&
    !window.confirm(confirmMessage)
  ) {
    return;
  }

  // 공유하기 쿠키 설정
  if (isNativeAppBoth && shareKakaotalk !== 'Y') {
    await setCookieShareKakaotalk('Y');
  }
  // 카카오톡 공유 실행
  window.Kakao?.Share?.sendScrap({
    requestUrl: url,
    installTalk: true,
  });
};
/**
 * Url 공유 (url 복사 -> 붙여넣기) - 이슈, 에디션,
 * Example  : WCK_CMM_SNS_RENEWAL_FN.urlCopy(curUrl);
 * @param curUrl : 현제 페이지 url
 */
export function urlCopy(curUrl: string) {
  let url = curUrl;
  if (
    url.toLowerCase().indexOf('http://') < 0 &&
    url.toLowerCase().indexOf('https://') < 0
  ) {
    url = `https://${url}`;
  }

  const IE = !!document.all;

  const IE11 = navigator.userAgent.search('Trident');
  let temp: string | null = '';
  let type = '';
  const tempUrl = window.location.href.toLowerCase();
  if (tempUrl.indexOf('/product') > -1) {
    type = '상품';
  } else if (tempUrl.indexOf('/issue') > -1 || tempUrl.indexOf('/event') > -1) {
    type = '기획전';
  } else if (tempUrl.indexOf('/edition') > -1) {
    type = '에디션';
  }

  if (IE || IE11 !== -1) {
    temp = prompt(`아래 ${type}의 주소를 복사해 주세요.`, url);
  } else {
    temp = prompt(`아래 ${type}의 주소를 복사해 주세요.`, url);
  }
}

/**
 * URL 카피 자동 클립보드에 카피 (ITDEV-929에서 추가)
 * @param {any} curUrl : 현제 페이지 url
 */
export async function urlToClipboard(curUrl: string) {
  let url = curUrl;
  if (
    url.toLowerCase().indexOf('http://') < 0 &&
    url.toLowerCase().indexOf('https://') < 0
  ) {
    url = `https://${url}`;
  }
  const textField = document.createElement('textarea');
  if (textField) {
    textField.innerText = url || '';
  }
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
  return Promise.resolve();
}
